import request from '@/utils/request';
export function fetchList(data) {
  return request({
    url: '/whg-park/api/activityItem/detailList',
    method: 'post',
    data: data
  });
}
export function fetchDetailList(data) {
  return request({
    url: '/whg-park/api/activeRegistration/detailList',
    method: 'post',
    data: data
  });
} // 添加

export function fetchCreate(data) {
  return request({
    url: '/whg-park/api/greenEvent/insert',
    method: 'post',
    data: data
  });
} // 删除

export function fetchDelete(data) {
  return request({
    url: '/whg-park/api/greenEvent/delete',
    method: 'post',
    data: data
  });
} // 编辑

export function fetchUpdate(data) {
  return request({
    url: '/whg-park/api/greenEvent/update',
    method: 'post',
    data: data
  });
} // 详情

export function fetchDetail(data) {
  return request({
    url: '/whg-park/api/greenEvent/get',
    method: 'post',
    data: data
  });
}
export function registerAndApprove(data) {
  return request({
    url: '/whg-park/api/activityItem/registerAndApprove',
    method: 'post',
    data: data
  });
}